import { useContext } from 'react';

import { TranslationsContext } from './TranslationsProvider';

export const useTranslations = () => useContext(TranslationsContext);
